import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class CircuitRaceRoute extends Route
{
	@service store;

	// Preload the async Ember Data relations that the circuit race component
	// needs so the getter can run synchronously and re-run cheaply each time
	// a new intermediate timing record lands via websocket.
	async model()
	{
		const event = this.modelFor('event');

		const [intermediateTimingPointsRel, classGroupsRel] = await Promise.all([
			event.intermediateTimingPoints,
			event.classGroups
		]);

		const intermediateTimingPoints = intermediateTimingPointsRel.slice();
		const classGroups = classGroupsRel.slice();

		const classGroupData = await Promise.all(classGroups.map(async (classGroup) =>
		{
			const [course, classesRel] = await Promise.all([
				classGroup.CourseId,
				classGroup.classes
			]);
			const classes = classesRel.slice();

			const entriesByClass = await Promise.all(classes.map(async (cls) =>
			{
				const entriesRel = await cls.entries;
				return {
					cls,
					entries: entriesRel.slice()
				};
			}));

			return { classGroup, course, entriesByClass };
		}));

		return {
			event,
			intermediateTimingPoints,
			classGroupData
		};
	}
}
